import React, { Component } from "react";
import NavigateNextRoundedIcon from "@mui/icons-material/NavigateNextRounded";
import NavigateBeforeRoundedIcon from "@mui/icons-material/NavigateBeforeRounded";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import IconButton from "@mui/material/IconButton";
import Theme from "../Theme";
import SummaryModul from "../SummaryModul";
import MessageModul from "../../MessageModul";
import DataStore from "../../stores/DataStore";

class PagesModul extends Component {
  /**
   * Modul, welches die Anzeige für Themen in einer Seitenansicht
   * @constructor
   */
  constructor(params) {
    super(params);
    this.messageModules = [];
    this.state = {
      currentTheme: 0,
    };
  }

  componentDidMount() {
    if (this.messageHandler && this.messageModules && this.messageModules[0]) {
      this.messageHandler.setMessageModul(this.messageModules[0]);
    }
    this.messageHandler.logDebugFormatted(
      "PagesModul",
      "componentDidMount",
      "",
      this.props,
      this.state,
      this.messageModules
    );
  }

  getSummary() {
    const { saveChangesHandler } = DataStore.getHandler();
    const summary = (
      <SummaryModul
        saveChangesHandler={saveChangesHandler}
        messageHandler={this.messageHandler}
      />
    );
    return summary;
  }

  getMessageModul() {
    return (
      <MessageModul
        onMounted={(modul) => this.messageModules.push(modul)}
        messageHandler={this.messageHandler}
      />
    );
  }

  getTheme(page) {
    const { themes, messageHandler, editToolbar } = this.props;
    this.messageHandler.logDebugFormatted(
      "PagesModul",
      "getTheme",
      page,
      this.props,
      this.state
    );
    if (page < themes.length) {
      return (
        <Theme
          themeOptions={themes[page]}
          messageHandler={messageHandler}
          messageModul={this.getMessageModul()}
          requestHandler={this.requestHandler}
          editToolbar={editToolbar}
        />
      );
    }
    return this.getSummary();
  }

  /**
   * @returns {Theme} angezeigtes Thema (Seite)
   */
  getCurrentTheme() {
    const { currentTheme } = this.state;
    const { themes, messageHandler } = this.props;
    return (
      <Theme
        themeOptions={themes[currentTheme]}
        messageHandler={messageHandler}
      />
    );
  }

  /**
   * @returns {div} Footer für die Seitennavigation
   */
  getFooter(page) {
    const { currentTheme } = this.state;
    const { themes, messageHandler } = this.props;
    if (!page) {
      page = currentTheme;
    }
    const rightButtonStyle = { float: "right" };
    const leftButtonStyle = { float: "left" };
    const navStyle = {
      display: "block",
      bottom: "0px",
      width: "100%",
    };
    const iconStyle = {
      fontSize: "30pt",
    };
    if (themes.length <= 1) {
      if (DataStore.requestStore.requests[DataStore.saveKey] == undefined) {
        return <div />
      }
      return (
        <BottomNavigation style={navStyle}>
          <BottomNavigationAction
            style={rightButtonStyle}
            aria-label="send"
            onClick={() => {
              this.handleSend();
            }}
            icon={<SendRoundedIcon style={iconStyle} />}
          />
        </BottomNavigation>
      );
    }
    if (page === 0) {
      return (
        <BottomNavigation style={navStyle}>
          <BottomNavigationAction
            aria-label="next"
            style={rightButtonStyle}
            onClick={() => {
              this.nextPage();
            }}
            icon={<NavigateNextRoundedIcon style={iconStyle} />}
          />
        </BottomNavigation>
      );
    }
    if (page === themes.length - 1) {
      return (
        <BottomNavigation style={navStyle}>
          <BottomNavigationAction
            style={leftButtonStyle}
            aria-label="previous"
            onClick={() => {
              this.previousPage();
            }}
            icon={<NavigateBeforeRoundedIcon style={iconStyle} />}
          />
          {DataStore.requestStore.requests[DataStore.saveKey] &&
            <BottomNavigationAction
              style={rightButtonStyle}
              aria-label="send"
              onClick={() => {
                this.handleSend();
              }}
              icon={<SendRoundedIcon style={iconStyle} />}
            />}
        </BottomNavigation>
      );
    }
    if (page === themes.length) {
      return (
        <BottomNavigation style={navStyle}>
          <BottomNavigationAction
            style={leftButtonStyle}
            aria-label="previous"
            onClick={() => {
              this.previousPage();
            }}
            icon={<NavigateBeforeRoundedIcon style={iconStyle} />}
          />
        </BottomNavigation>
      );
    }

    return (
      <BottomNavigation style={navStyle}>
        <BottomNavigationAction
          style={leftButtonStyle}
          aria-label="previous"
          onClick={() => {
            this.previousPage();
          }}
          icon={<NavigateBeforeRoundedIcon style={iconStyle} />}
        />
        <BottomNavigationAction
          aria-label="next"
          style={rightButtonStyle}
          onClick={() => {
            this.nextPage();
          }}
          icon={<NavigateNextRoundedIcon style={iconStyle} />}
        />
      </BottomNavigation>
    );
  }

  /**
   * @return {object} alle Themen (mit genau einem Sichtbar)
   */
  getPages() {
    const { themes = [] } = this.props;
    const { currentTheme } = this.state;
    const pages = [];
    if (
      this.messageHandler &&
      this.messageModules &&
      this.messageModules[currentTheme]
    ) {
      this.messageHandler.setMessageModul(this.messageModules[currentTheme]);
    }
    for (let i = 0; i <= themes.length; i++) {
      const displayStyle = i == currentTheme ? "block" : "none";
      pages.push(
        <div
          key={`PagesModulPage${i}`}
          style={{ display: displayStyle, height: "100%" }}
        >
          {this.getPage(i)}
        </div>
      );
    }
    this.messageHandler.logDebugFormatted(
      "PagesModul",
      "getPages",
      "",
      this.props,
      this.state,
      pages
    );
    return <div style={{ flexGrow: 1, overflow: "auto" }}>{pages}</div>;
  }

  getPage(page) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      // {{
      //   height: "100%",
      //   width: "100%",
      //   display: "flex",
      //   flexDirection: "column",
      // }}
      >
        <div style={{ flexGrow: 1, overflow: "auto" }}>
          {this.getTheme(page)}
        </div>
        <div
          style={{
            flexGrow: 0,
            // display: "flex",
            // flexDirection: "row",
            // justifyConten t: "space-around",
          }}
        >
          {this.getFooter(page)}
        </div>
      </div>
    );
  }

  //   <div
  //           style={{
  //             height: '100%',
  //             width: '100%',
  //             display: 'flex',
  //             flexDirection: 'column',
  //           }}
  //         >
  //           <div style={{ flexGrow: 0 }}>
  //           </div>

  //           <div style={{ flexGrow: 1, overflow: 'auto' }}>
  //           </div>

  //           <div style={{ flexGrow: 0 }}>
  //           </div>
  // </div>

  /**
   * Handlet den Klick auf den Sendbutten bei der letzten Seite
   */
  handleSend() {
    const { saveChangesHandler } = DataStore.getHandler();
    saveChangesHandler.saveChanges(
      () => this.nextPage(),
      (errorLog) => {
        const errDetail = errorLog.map((o) => (
          <div>
            <div style={{ float: "left", marginRight: "5px" }}>
              {`${o.name}: `}
            </div>
            {o.errText.map((t) => (
              <div>{t}</div>
            ))}
          </div>
        ));
        this.messageHandler.logDebugFormatted(
          "PagesModul",
          "handleSendErrorAnonym",
          "",
          this.props,
          this.state,
          errorLog
        );
        this.messageHandler.setMessage(
          "error",
          "Fehler im Formular",
          errDetail
        );
      }
    );
  }

  /**
   * Nächste Seite anzeigen
   */
  nextPage() {
    const { currentTheme } = this.state;
    const { themes, messageHandler } = this.props;

    if (currentTheme < themes.length) {
      this.setState({ currentTheme: currentTheme + 1 });
    }
  }

  /**
   * vorige Seite anzeigen
   */
  previousPage() {
    const { currentTheme } = this.state;
    const { messageHandler } = this.props;
    if (currentTheme >= 1) {
      this.setState({ currentTheme: currentTheme - 1 });
    }
  }

  /**
   * Modul, welches die Anzeige für das spezielle Attribut erstellt.
   * @render
   * @param {Array} themes - Array mit Themen
   * @param {Array} attributes - Falls keine Themen vorhanden: Array der Attribute
   */
  render() {
    const { themes = [], attributes = [] } = this.props;
    this.messageHandler = DataStore.getHandler().messageHandler;
    this.requestHandler = DataStore.getHandler().requestHandler;
    this.messageHandler.logDebugFormatted(
      "PagesModul",
      "render",
      "",
      this.props,
      this.state
    );
    return this.getPages();
    // <div style={{ height: '100%' }}>
    //   <div>{this.getCurrentTheme()}</div>
    //   {this.getFooter()}
  }
}
export default PagesModul;
